import { ContiguousTimeslot } from "../timeslots.types";

/**
 * Extract valid slot IDs from contiguous timeslots that meet minimum duration.
 * Returns deduplicated slot IDs since the same weekly slot ID (0-335) can appear
 * multiple times when selections span multiple weeks.
 */
export function getValidTimeslotsFromContiguousTimeslots(
  contiguousTimeslots: ContiguousTimeslot[],
  minDuration: number = 2
) {
  if (contiguousTimeslots.length === 0) return [];

  const slotIds = contiguousTimeslots
    .filter((timeslot) => timeslot.duration >= minDuration)
    .map((timeslot) => timeslot.slotIds)
    .flat();

  // Deduplicate since the same weekly slot ID can appear across multiple weeks
  return [...new Set(slotIds)];
}

export default getValidTimeslotsFromContiguousTimeslots;

